import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import animateScrollTo from 'animated-scroll-to';
import GridCoverItem from './GridCoverItem';


class GridCover extends Component {
  constructor (props) {
    super(props);
    this.state = { activeItemId: null };
    this.handleItemActivate = this.handleItemActivate.bind(this);
  }

  componentWillUnmount () {
    clearTimeout(this.scrollTimeout);
  }

  handleItemActivate (el, uid) {
    const { breakpoint } = this.props;
    this.setState({ activeItemId: uid });
    if (breakpoint.lessThan.lg) {
      this.scrollTimeout = setTimeout(() => {
        animateScrollTo(el, { element: this.containerRef });
      }, 400);
    }
  }

  render () {
    const { longDescription, items, footerText } = this.props;
    const { activeItemId } = this.state;
    const firstRowItems = items.slice(0, 4);
    const secondRowItems = items.slice(4);

    return (
      <div className="grid-cover-container" ref={node => this.containerRef = node}>
        <div className="grid-cover-items-row">
          {firstRowItems.map(item => (
            <GridCoverItem
              key={item.uid}
              {...item}
              activeItemId={activeItemId}
              onActivate={el => this.handleItemActivate(el, item.uid)}
            />
          ))}
        </div>
        {!!longDescription && (
          <div className="grid-cover-text-row">
            <div className="grid-cover-text body-copy" dangerouslySetInnerHTML={{ __html: longDescription }} />
          </div>
        )}
        <div className="grid-cover-items-row">
          {secondRowItems.map(item => (
            <GridCoverItem
              key={item.uid}
              {...item}
              activeItemId={activeItemId}
              onActivate={el => this.handleItemActivate(el, item.uid)}
            />
          ))}
        </div>
        {!!footerText && <footer className="grid-cover-footer" dangerouslySetInnerHTML={{ __html: footerText }} />}
      </div>
    );
  }
}

GridCover.propTypes = {
  longDescription: PropTypes.string,
  footerText: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    uid: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.object,
    buttonText: PropTypes.string,
    linkType: PropTypes.oneOf(['title', 'media']),
    titleId: PropTypes.string,
    mediaId: PropTypes.string,
  })),
};

const mapStateToProps = ({ breakpoint, ui, sections }) => ({ breakpoint, ui, sections });

export default connect(mapStateToProps)(GridCover);



// WEBPACK FOOTER //
// ./src/components/GridCover/GridCover.js